import { render, staticRenderFns } from "./DefaultContact.vue?vue&type=template&id=670d5fb8&scoped=true&"
import script from "./DefaultContact.vue?vue&type=script&lang=js&"
export * from "./DefaultContact.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContact.vue?vue&type=style&index=0&id=670d5fb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d5fb8",
  null
  
)

export default component.exports